import React from "react";
import { Card } from "../../../components/template";

const CorporateWellness = () => {
  const programs = [
    {
      title: "Junior & Mid Level",
 gain:"A 4 step unique program for your team’s holistic growth & inner excellence",
      image:
        "/assets/home/Corporate.jpeg",

      link:
        "/corporate-wellness/junior",
    },

    {
      title: "CXOs & Senior Leaders",


      gain:
        "A 3 step program for inner empowerment & rejuvenation of the leaders",

      image:
        "/assets/thrive/INSIGHT Image.jpeg",

      link:
        "/corporate-wellness/senior",
    },
  ];

  return (
    <main className="bg-[#F7F1EA] min-h-screen">

      {/* ================================================= */}
      {/* HERO */}
      {/* ================================================= */}

      <section className="pt-14 pb-10 px-6">

        <div className="max-w-[1400px] mx-auto">

          {/* TOP CONTENT */}
          <div
            className="
              text-center
              max-w-[980px]
              mx-auto
              mb-16
            "
          >

            {/* LABEL */}
            <div
              className="
                inline-flex
                items-center
                px-5
                py-2
                rounded-full
                bg-[#FFF4E8]
                border
                border-[#F3DDC7]
                text-[#C26B2E]
                text-[11px]
                tracking-[.18em]
                uppercase
                font-medium
                mb-6
              "
            >
              Corporate Wellness
            </div>

             <h1
              className="
                text-[clamp(52px,7vw,96px)]
                leading-[.95]
                tracking-[-0.05em]
                text-secondary
                mb-8
              "
            >
              Corporate Wellness Programs
            </h1>
 
            {/* DESCRIPTION */}
            {/* <p
              className="
                text-[#5F5751]
                text-[17px]
                md:text-[18px]
                leading-9
                max-w-[820px]
                mx-auto
                mb-6
              "
            >
              Modern teams are operating under
              constant pressure — leading to
              burnout, emotional exhaustion,
              disengagement, and declining
              productivity.
            </p> */}

            {/* <p
              className="
                text-[#5F5751]
                text-[17px]
                md:text-[18px]
                leading-9
                max-w-[820px]
                mx-auto
              "
            >
              True high performance doesn’t come
              from working harder — it comes from
              unlocking deeper energy, emotional
              resilience, clarity, and intrinsic
              motivation.
            </p> */}
          </div>

          {/* GRID */}
          <div
            className="
              grid
              grid-cols-1
              md:grid-cols-2
              gap-8
              max-w-[1100px]
              mx-auto
            "
          >
            {programs.map((program, index) => (
              <Card
                key={index}
                {...program}
              />
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default CorporateWellness;
